import * as React from 'react';
import { Modal } from './Modal';
import { Autocomplete, Button, FormControl, FormControlLabel, InputAdornment, InputLabel, Stack, TextField, Typography } from '@mui/material';

import SearchIcon from '@mui/icons-material/Search';
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import CancelIcon from '@mui/icons-material/Cancel';

export const EmulateUserModal = () => {
    return <Modal title={"Emulate User"}
                  description={"View information as another user would see it."}
                  cancel
                  buttons={[<Button startIcon={<AccountBoxIcon/>}>{"Emulate User"}</Button>]}>
        <FormControl fullWidth sx={{marginBottom: 20}}>
            <Autocomplete
                options={[{label: 'User1'}, {label: 'User2'}, {label: 'User3'}, {label: 'User4'}]}
                renderInput = {
                    (params) => <TextField {...params} label={"Filter User"}
                        slotProps={{
                            input: {
                                startAdornment: <InputAdornment position='start'><SearchIcon /></InputAdornment>
                            },
                        }}
                    />
                }
                getOptionLabel={(option) => option.label}
            />
        </FormControl>
    </Modal>
}